import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class SecurityManager {

    constructor(private router: Router) { }


    saveToken(credential) {
        localStorage.setItem('userCredential', JSON.stringify(credential));
    }
      removeToken() {
        localStorage.setItem('userCredential', null);
    }
    getToken() {

        return JSON.parse(localStorage.getItem('userCredential'));
    }


    checkToken() {
        if (this.getToken()) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.sec.component.ts